import { Component, OnInit, OnDestroy, Output, EventEmitter, signal, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrimeNGModule } from '../config/primeng';
import { Router, RouterModule } from '@angular/router';
import { AlarmsService, GetAlarmsResponse } from '@/app/core/services/alarms.service';
import { OmniMqttService } from '@/app/core/mqtt/omni-mqtt.service';
import { SystemTimeService } from '@/app/core/services/system-time.service';
import { UserService } from '@/app/core/services/user.service';
import { AuthenticateService } from '@/app/core/services/authenticate.service';
import { Subscription } from 'rxjs';

export type AlarmItem = GetAlarmsResponse['data'][0];

@Component({
  selector: 'app-header',
  imports: [CommonModule, PrimeNGModule, RouterModule],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  visible = false;
  private alarmSub?: Subscription;

  alarms = signal<AlarmItem[]>([]);
  unresolvedCount = signal(0);

  @Output() toggleMenu = new EventEmitter<void>();

  private alarmsService = inject(AlarmsService);
  public mqttService = inject(OmniMqttService);
  public systemTimeService = inject(SystemTimeService);
  public userService = inject(UserService);
  public authService = inject(AuthenticateService);

  debugMqttActive = signal<boolean>(localStorage.getItem('debug_mqtt') === 'true');
  private logoClickCount = 0;
  private logoClickTimer: any = null;

  constructor(public router: Router) { }

  ngOnInit() {
    // 初始載入未解除告警數
    this.loadAlarms();
    // 收到即時告警封包時自動重新查詢
    this.alarmSub = this.mqttService.alarms$.subscribe(() => this.loadAlarms());
  }

  ngOnDestroy() {
    this.alarmSub?.unsubscribe();
  }


  async onBellClick(event: Event, op: any) {
    op.toggle(event);
    await this.loadAlarms();
  }

  async loadAlarms() {
    this.alarmsService.getAlarms({
      statuses: [0]
    }).subscribe({
      next: (res: GetAlarmsResponse) => {
        this.alarms.set(res.data ?? []);
        this.unresolvedCount.set(res.pagination?.totalCount ?? 0);
      },
      error: (err: any) => {
        console.error('Failed to load alarms', err);
      }
    });
  }

  showDialog() {
    this.visible = true;
  }

  logout() {
    this.router.navigate(['/login']);
  }

  isDeveloper(): boolean {
    if (this.debugMqttActive()) {
      return true;
    }
    const roleName = this.userService.currentUser()?.role?.roleName;
    if (roleName) {
      const devRoles = ['系統管理員', '管理員', 'developer', 'admin', 'administrator'];
      return devRoles.some(role => roleName.toLowerCase().includes(role));
    }
    return false;
  }

  onLogoClick() {
    this.logoClickCount++;

    if (this.logoClickTimer) {
      clearTimeout(this.logoClickTimer);
    }

    this.logoClickTimer = setTimeout(() => {
      this.logoClickCount = 0;
    }, 3000);

    if (this.logoClickCount >= 5) {
      this.logoClickCount = 0;
      if (this.logoClickTimer) {
        clearTimeout(this.logoClickTimer);
      }

      const nextVal = !this.debugMqttActive();
      localStorage.setItem('debug_mqtt', nextVal ? 'true' : 'false');
      this.debugMqttActive.set(nextVal);

      alert(nextVal ? '🔧 已啟用開發者偵錯模式' : '🔒 已關閉開發者偵錯模式');
    }
  }
}
